module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "registration-title"
  }, [(_vm.FormInputs.IndividualLabels || _vm.FormInputs.BusinessLabels) ? _c('div', [_vm._v("\n          Association Information and Communication Preferences\n        ")]) : _vm._e(), _vm._v(" "), (_vm.FormInputs.NonProfitLabels) ? _c('div', [_vm._v("Communication Preferences")]) : _vm._e()])]), _vm._v(" "), (
    _vm.FormInputs.IndividualOrganization || _vm.FormInputs.BusinessOrganization
  ) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('label', [_vm._v(" Please select all of your professional affiliations. ")]), _vm._v(" "), _vm._l((_vm.CheckboxBusiness), function(value, key) {
    return (_vm.FormInputs.BusinessOrganization) ? _c('div', {
      staticClass: "form-check"
    }, [_c('label', {
      staticClass: "form-check-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.Account.Organizations.List),
        expression: "Account.Organizations.List"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": key,
        "checked": Array.isArray(_vm.Account.Organizations.List) ? _vm._i(_vm.Account.Organizations.List, key) > -1 : (_vm.Account.Organizations.List)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.Account.Organizations.List,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.Account.Organizations, "List", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.Account.Organizations, "List", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.Account.Organizations, "List", $$c)
          }
        }
      }
    }), _vm._v("\n          " + _vm._s(key) + "\n        ")])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.CheckboxIndividual), function(value, key) {
    return (_vm.FormInputs.IndividualOrganization) ? _c('div', {
      staticClass: "form-check"
    }, [_c('label', {
      staticClass: "form-check-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.Account.Organizations.List),
        expression: "Account.Organizations.List"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": key,
        "checked": Array.isArray(_vm.Account.Organizations.List) ? _vm._i(_vm.Account.Organizations.List, key) > -1 : (_vm.Account.Organizations.List)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.Account.Organizations.List,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.Account.Organizations, "List", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.Account.Organizations, "List", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.Account.Organizations, "List", $$c)
          }
        }
      }
    }), _vm._v("\n          " + _vm._s(key) + "\n        ")])]) : _vm._e()
  }), _vm._v(" "), (_vm.Account.Organizations.List.indexOf('Other') >= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v("\n          Please enter any other professional organizations you are associated\n          with separated by semicolon(;).\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.Organizations.Others),
      expression: "Account.Organizations.Others"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Account.Organizations.Others)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.Account.Organizations, "Others", $event.target.value)
      }
    }
  })]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div_bottom"
  }, [(
    _vm.FormInputs.IndividualOrganization || _vm.FormInputs.BusinessOrganization
  ) ? _c('label', {
    staticClass: "label-heading"
  }, [_vm._v("\n        Communication Preferences\n      ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "no-margin-bot"
  }, [_vm._v("Please confirm communication preferences.")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.ToBeContactedAsVolunteer),
      expression: "Account.ToBeContactedAsVolunteer"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Account.ToBeContactedAsVolunteer) ? _vm._i(_vm.Account.ToBeContactedAsVolunteer, null) > -1 : (_vm.Account.ToBeContactedAsVolunteer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Account.ToBeContactedAsVolunteer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Account, "ToBeContactedAsVolunteer", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Account, "ToBeContactedAsVolunteer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Account, "ToBeContactedAsVolunteer", $$c)
        }
      }
    }
  }), _vm._v("\n          I would like to be contacted if there are volunteer opportunities in\n          my area.\n        ")]), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.ToReceiveNewsLetter),
      expression: "Account.ToReceiveNewsLetter"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Account.ToReceiveNewsLetter) ? _vm._i(_vm.Account.ToReceiveNewsLetter, null) > -1 : (_vm.Account.ToReceiveNewsLetter)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Account.ToReceiveNewsLetter,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Account, "ToReceiveNewsLetter", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Account, "ToReceiveNewsLetter", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Account, "ToReceiveNewsLetter", $$c)
        }
      }
    }
  }), _vm._v("\n          I would like email updates from OneSight EssilorLuxottica Foundation.\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div_bottom"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.HowDoYouPlanOnServingThosePatient),
      expression: "Account.HowDoYouPlanOnServingThosePatient"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "Serve walk ins and sporadic referrals in my office",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Account.HowDoYouPlanOnServingThosePatient) ? _vm._i(_vm.Account.HowDoYouPlanOnServingThosePatient, "Serve walk ins and sporadic referrals in my office") > -1 : (_vm.Account.HowDoYouPlanOnServingThosePatient)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Account.HowDoYouPlanOnServingThosePatient,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Serve walk ins and sporadic referrals in my office",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Account, "HowDoYouPlanOnServingThosePatient", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Account, "HowDoYouPlanOnServingThosePatient", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Account, "HowDoYouPlanOnServingThosePatient", $$c)
        }
      }
    }
  }), _vm._v("\n          Serve walk ins and sporadic referrals in my office\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.HowDoYouPlanOnServingThosePatient),
      expression: "Account.HowDoYouPlanOnServingThosePatient"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "Host a vision event(s)",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Account.HowDoYouPlanOnServingThosePatient) ? _vm._i(_vm.Account.HowDoYouPlanOnServingThosePatient, "Host a vision event(s)") > -1 : (_vm.Account.HowDoYouPlanOnServingThosePatient)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Account.HowDoYouPlanOnServingThosePatient,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Host a vision event(s)",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Account, "HowDoYouPlanOnServingThosePatient", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Account, "HowDoYouPlanOnServingThosePatient", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Account, "HowDoYouPlanOnServingThosePatient", $$c)
        }
      }
    }
  }), _vm._v("\n          Host a vision event(s)\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.HowDoYouPlanOnServingThosePatient),
      expression: "Account.HowDoYouPlanOnServingThosePatient"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "Partner with a local non profit or school to receive their referrals in my office",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Account.HowDoYouPlanOnServingThosePatient) ? _vm._i(_vm.Account.HowDoYouPlanOnServingThosePatient, "Partner with a local non profit or school to receive their referrals in my office") > -1 : (_vm.Account.HowDoYouPlanOnServingThosePatient)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Account.HowDoYouPlanOnServingThosePatient,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Partner with a local non profit or school to receive their referrals in my office",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Account, "HowDoYouPlanOnServingThosePatient", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Account, "HowDoYouPlanOnServingThosePatient", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Account, "HowDoYouPlanOnServingThosePatient", $$c)
        }
      }
    }
  }), _vm._v("\n          Partner with a local non profit or school to receive their referrals in my office\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.HowDoYouPlanOnServingThosePatient),
      expression: "Account.HowDoYouPlanOnServingThosePatient"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "Volunteer at local clinics, health fairs, or vision events",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Account.HowDoYouPlanOnServingThosePatient) ? _vm._i(_vm.Account.HowDoYouPlanOnServingThosePatient, "Volunteer at local clinics, health fairs, or vision events") > -1 : (_vm.Account.HowDoYouPlanOnServingThosePatient)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Account.HowDoYouPlanOnServingThosePatient,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Volunteer at local clinics, health fairs, or vision events",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Account, "HowDoYouPlanOnServingThosePatient", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Account, "HowDoYouPlanOnServingThosePatient", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Account, "HowDoYouPlanOnServingThosePatient", $$c)
        }
      }
    }
  }), _vm._v("\n          Volunteer at local clinics, health fairs, or vision events\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Account.HowDoYouPlanOnServingThosePatient),
      expression: "Account.HowDoYouPlanOnServingThosePatient"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "I’m not sure",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.Account.HowDoYouPlanOnServingThosePatient) ? _vm._i(_vm.Account.HowDoYouPlanOnServingThosePatient, "I’m not sure") > -1 : (_vm.Account.HowDoYouPlanOnServingThosePatient)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Account.HowDoYouPlanOnServingThosePatient,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "I’m not sure",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.Account, "HowDoYouPlanOnServingThosePatient", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.Account, "HowDoYouPlanOnServingThosePatient", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.Account, "HowDoYouPlanOnServingThosePatient", $$c)
        }
      }
    }
  }), _vm._v("\n          I’m not sure\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "registration-title"
  }, [_c('div', [_vm._v("How do you plan on serving those patients? (check all that apply)")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-bc785b72", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc785b72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountDetails/AssociationAndCommunication.vue
// module id = 543
// module chunks = 3